'use client'

import clsx from 'clsx'
import {useState} from 'react'
import s from './style.module.scss'
import {ScriptPriorityType} from '@gamezop/ads-sdk/types'
import useCCPADialogWatch from './use-ccpa-dialog-watch'
import triggerAnalytics from '@gamezop/analytics-sdk/client/trigger-analytics'
import {FooterEvent} from '../../analytics/events'

declare global {
  interface Window {
    __uspapi: any
    __tcfapi: any
  }
}

interface Props {
  className: string
  adScripts: ScriptPriorityType[]
  country: string
}

const DoNotSellPersonalInfo = ({className, adScripts, country}: Props) => {
  const [isLoading, setLoading] = useState<boolean>(false)
  const listenToDialogOpen = useCCPADialogWatch({
    onDialogOpen: () => {
      setLoading(false)
      triggerAnalytics(FooterEvent.DoNotSellInfoVisible).sendAll()
    },
  })

  function onClick() {
    triggerAnalytics(FooterEvent.DoNotSellInfoVisible).sendAll()
    if ('__uspapi' in window && '__tcfapi' in window) {
      setLoading(true)
      if (country === 'US') {
        window.__uspapi('displayUspUi')
      } else {
        window.__tcfapi('displayConsentUi', 2, () => {})
      }
      listenToDialogOpen()
    }
    triggerAnalytics(FooterEvent.DoNotSellClicked).sendAll()
  }

  return (
    <button onClick={onClick} className={clsx(className, s.text_loader, {[s.active]: isLoading})}>
      {country === 'US' ? 'Do Not Sell My Personal Information' : 'Privacy Settings'}
    </button>
  )
}

export default DoNotSellPersonalInfo
